var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDevops(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E86C60",
    d: "M18,31c-0.256,0-0.512-0.098-0.707-0.293c-0.391-0.391-0.391-1.023,0-1.414l24-24 c0.391-0.391,1.023-0.391,1.414,0s0.391,1.023,0,1.414l-24,24C18.512,30.902,18.256,31,18,31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#595959",
    d: "M45,36H13c-0.552,0-1-0.448-1-1V3c0-0.552,0.448-1,1-1h4c0.552,0,1,0.448,1,1v27h27c0.552,0,1,0.448,1,1v4 C46,35.552,45.552,36,45,36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#595959",
    d: "M35,46h-4c-0.552,0-1-0.448-1-1V18H3c-0.552,0-1-0.448-1-1v-4c0-0.552,0.448-1,1-1h32c0.552,0,1,0.448,1,1 v32C36,45.552,35.552,46,35,46z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 18,
    fill: "#444444",
    width: 6,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 36,
    fill: "#444444",
    width: 6,
    height: 3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevops);
export default __webpack_public_path__ + "static/media/devops.a17e5c7faf63822489902798c5664c3f.svg";
export { ForwardRef as ReactComponent };